import { Flex, notification, Typography } from "antd"

import { IdItem } from "@src/app/components/tableRowItems/idItem"
import { WithCopy } from "@src/shared/componemts/WithCopy"
import { paddingLimit } from "@src/shared/strings"

const { error, success } = notification

export const notify = {
  /**
   * @example
   * notify.error()
   * @example
   * notify.error('error message')
   */
  error: (message?: string, traceId?: string) => {
    const duration = 1000

    const errorTemplate = (
      <Flex gap={12} vertical>
        <Typography.Text>{message}</Typography.Text>

        {traceId && (
          <Flex gap={4} vertical>
            <Typography.Text>x-trace-id:</Typography.Text>
            <IdItem id={traceId} p={traceId.length} />
          </Flex>
        )}
      </Flex>
    )

    if (message) {
      error({
        description: traceId
          ? traceId && (
              <Flex
                gap={16}
                justify="flex-start"
                style={{ marginTop: 10, width: "100%" }}
              >
                <Typography.Text style={{ textTransform: "uppercase" }}>
                  x-trace-id:
                </Typography.Text>
                <WithCopy
                  content={traceId}
                  view={<span>{paddingLimit(traceId, 0, 8)}</span>}
                />
              </Flex>
            )
          : undefined,
        duration,
        message: message,
      })
    } else {
      error({
        description: "Please try again later",
        duration,
        message: "Server error",
      })
    }
  },
  /**
   * @example
   * notify.success()
   * @example
   * notify.success('success message')
   * @example
   * notify.success([ 'title', 'description' ])
   */
  success: (text?: [string, string] | string) => {
    if (typeof text !== "string") success({ message: "Completed successfully" })

    if (typeof text === "string") success({ message: text })

    if (Array.isArray(text)) success({ description: text[1], message: text[0] })
  },
}
